var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
// Renders an image, falling back to a defined image source in case of errors
export var Image = function (_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, _c = _a.fallbackSrc, fallbackSrc = _c === void 0 ? '' : _c, props = __rest(_a, ["src", "fallbackSrc"]);
    var _d = useState(false), hasError = _d[0], setHasError = _d[1];
    // TODO : update types for e
    var handleError = function (e) {
        if (!hasError && fallbackSrc) {
            e.target.src = fallbackSrc;
            setHasError(true);
        }
    };
    return <img src={src} data-testid="img-with-fallback" onError={handleError} {...props}/>;
};
